import React from 'react'
import { HelmetProvider, Helmet } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from 'react-query'
import { Toaster } from 'react-hot-toast'
import { ReactQueryDevtools } from 'react-query/devtools'

import { APP_TITLE } from './utils/config'
import { queryClient } from './utils/react-query'

import Routes from './Routes'
import ErrorBoundary from './components/ErrorBoundary'
import Auth from './components/auth/Auth'

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <Helmet titleTemplate={`%s | ${APP_TITLE}`} defaultTitle={APP_TITLE} />
        <Toaster position="top-right" />

        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />

            <Auth>
              <Routes />
            </Auth>
          </QueryClientProvider>
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  )
}

export default App
